import { Reveal, ChapterTag } from "./motion";
import { useStore } from "../../context/StoreContext";
import { PawPrint, Camera, Star } from "lucide-react";

export const SocialProof = () => {
  const { config } = useStore();
  return (
    <section id="opiniones" data-testid="social-proof-section" className="py-16 sm:py-24 lg:py-32">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
        <Reveal>
          <div className="flex justify-center"><ChapterTag num="08" label="Community" /></div>
          <span className="mx-auto w-14 h-14 rounded-full bg-brand-soft flex items-center justify-center mb-6">
            <PawPrint className="w-6 h-6 text-brand" />
          </span>
          <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-balance" data-testid="social-proof-text">
            {config?.social_proof_text || "We're testing it in homes with dogs and cats."}
          </h2>
          <p className="mt-4 text-sm sm:text-base text-zinc-500 flex items-center justify-center gap-2 flex-wrap">
            <Camera className="w-4 h-4" />
            Real reviews with photos and
            <span className="inline-flex items-center gap-0.5"><Star className="w-4 h-4 text-amber-400" /> star ratings coming soon.</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
};
